// @flow
import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useSnackbar } from 'notistack';
import * as React from 'react';

import { StoreContext } from '../context/store-context';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.primary.main,
    color: 'white',
    paddingTop: 9,
    marginLeft: theme.spacing(3),
    paddingBottom: 9,
    border: '2px solid black',

    '&:hover': {
      color: 'black',
      border: '2px solid black',
    },

    '&:disabled': {
      color: 'white',
    },
  },
}));

type AddToCartProps = {
  variantId?: string,
  quantity?: number,
  available?: boolean,
};

export default function AddToCart({
  variantId,
  quantity,
  available,
  ...props
}: AddToCartProps) {
  const classes = useStyles();
  const { addVariantToCart, loading } = React.useContext(StoreContext);
  const { enqueueSnackbar } = useSnackbar();

  const addToCart = () => {
    enqueueSnackbar('Actualizando carrito...', {
      variant: 'info',
    });

    addVariantToCart(variantId, quantity);

    setTimeout(
      () =>
        enqueueSnackbar('Agregado al carrito', {
          variant: 'success',
        }),
      1000,
    );
  };

  return (
    <Button
      variant="outlined"
      onClick={addToCart}
      className={classes.root}
      disabled={!available || loading}
      {...props}
    >
      {available ? 'Agregar al carrito' : 'Agotado'}
    </Button>
  );
}
